module.exports = __webpack_public_path__ + "img/restaurants_bars.3bd5ea32.svg";